import FormSystemError from "../utils/form-error-constants";
import {cloudflareTurnstileService} from "./botProtection/cloudflareTurnstileService";

const mq = window.matchMedia('(max-width: 740px)');
const isMobile = mq.matches;

const FAILED_CODE = 0;
const ALREADY_SUBSCRIBED_CODE = 2;
const INVALID_CODE = 3;

const hideNotifications = ($parent) => {
    $parent.find('.notification.newsletter.failed').addClass('hidden');
    $parent.find('.notification.newsletter.success').addClass('hidden');
    $parent.find('.notification.newsletter.subscribed').addClass('hidden');
};

const renderNotifications = (form, data) => {
    const $form = $(form);
    const $parent = $(form.closest('.js_newsletter'));
    const formSystemError = new FormSystemError($form);

    if (data.statusCode === ALREADY_SUBSCRIBED_CODE) {
        $parent.find('.notification.newsletter.subscribed').removeClass('hidden');

        return;
    }

    if (data.statusCode === FAILED_CODE || data.statusCode === INVALID_CODE) {
        formSystemError.showNoticeErrorAfter(
            $form,
            $form,
            formSystemError.constants.clang_newsletter_subscription_failed
        );

        return;
    }

    $parent.find('.notification.newsletter.success').removeClass('hidden');
};

$(document).ready(function () {
    if (isMobile) {
        $('.js_desktop-newsletter').remove();
    }

    $('.newsletterForm button').on('click', (event) => {
        event.preventDefault();

        const $form = $(event.target).closest('form');
        const $parent = $($form.closest('.js_newsletter'));
        const formSystemError = new FormSystemError($form);

        hideNotifications($parent);
        formSystemError.removeErrors($parent);

        const $unfilledRequired = $form.find('input:required').filter((index, element) => {
            return $(element).val().length === 0;
        });

        if ($unfilledRequired.length && $form.hasClass('blog-newsletter') ) {
            formSystemError.hideNoticeErrorNext($form, $form);
            formSystemError.showNoticeErrorAfter(
                $form,
                $form,
                formSystemError.constants.field_required
            );

            return;
        }

        if ($unfilledRequired.length) {
            formSystemError.init();

            return;
        }

        cloudflareTurnstileService.submitFormWithChallenge($form);
    });

    $('.newsletterForm').submit((event) => {
        event.preventDefault();

        const $form = $(event.target).closest('form');

        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: $form.serialize() + '&source=' + encodeURIComponent(window.location.href),
        }).done((data) => {
            $form.find('input')[0].value = '';
            renderNotifications($form, data);
        }).always(() => {
            cloudflareTurnstileService.clearTurnstileContainer();
        });
    });
});
